var exports = {
  "w": "x2b2fbebb--2551dc--header",
  "D": "x2b2fbebb--2551dc--title",
};

module.exports = exports;
